import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const EnvelopeIcon = ({ label = 'Envelope', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><rect x="39.9" y="73.9" width="213" height="152.12" rx="5.5" style="fill:#84cee3"/><path d="M247.3 73.9a5.6 5.6 0 0 1 5.5 5.6v141a5.6 5.6 0 0 1-5.5 5.6H45.4a5.6 5.6 0 0 1-5.5-5.6v-141a5.6 5.6 0 0 1 5.5-5.6h201.9m0-10H45.4a15.5 15.5 0 0 0-15.5 15.6v141a15.5 15.5 0 0 0 15.5 15.6h201.9a15.6 15.6 0 0 0 15.5-15.6v-141a15.6 15.6 0 0 0-15.5-15.6z" style="fill:#1d1d1b"/><path d="M146.4 189.2a24.5 24.5 0 0 1-14.3-4.7L31.6 110.8a5.1 5.1 0 0 1-1.1-7 5 5 0 0 1 7-1.1L138 176.4a14.1 14.1 0 0 0 16.8 0l100.4-73.7a5 5 0 0 1 7 1.1 5.1 5.1 0 0 1-1.1 7l-100.4 73.6a23.7 23.7 0 0 1-14.3 4.8zm90.5 29.1h-26.1a3.5 3.5 0 0 1 0-7h26.1a1.6 1.6 0 0 0 1.6-1.5v-4.4a3.5 3.5 0 0 1 3.5-3.5 3.5 3.5 0 0 1 3.5 3.5v4.4a8.6 8.6 0 0 1-8.6 8.5zm5.1-20.4a3.5 3.5 0 0 1-3.5-3.5v-3.9a3.5 3.5 0 0 1 3.5-3.5 3.5 3.5 0 0 1 3.5 3.5v3.9a3.5 3.5 0 0 1-3.5 3.5z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

EnvelopeIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { EnvelopeIcon }
